import { SHOP } from "@/data/menu";

export const formatOrderText = (o) => {
  const lines = [
    `New order ${o.order_number || ""} - ${SHOP.name}`.trim(),
    `Name: ${o.customer_name}`,
    `Phone: ${o.phone}`,
  ];
  if (o.email) lines.push(`Email: ${o.email}`);
  lines.push(`${o.fulfillment === "delivery" ? "Delivery" : "Pickup"}${o.date_needed ? ` on ${o.date_needed}` : ""}`);
  if (o.occasion) lines.push(`Occasion: ${o.occasion}`);
  lines.push("", "Order:");
  (o.items || []).forEach((i) => {
    lines.push(`- ${i.qty} x ${i.category}: ${i.name}${i.note ? ` (${i.note})` : ""}`);
  });
  if (o.notes) lines.push("", `Notes: ${o.notes}`);
  lines.push("", "Please send me a quote. Thank you!");
  return lines.join("\n");
};

export const smsLink = (text, to = SHOP.phone) => `sms:+1${to}?&body=${encodeURIComponent(text)}`;

export const mailLink = (o, text) =>
  `mailto:${SHOP.email}?subject=${encodeURIComponent(`New Bakery Order ${o.order_number || ""} - ${o.customer_name}`)}&body=${encodeURIComponent(text)}`;
